import { forwardRef } from 'react'

import { isVisualRegressionEnv } from '~/utils/is-visual-regression-env'
import { getGradientStyles, useWrapperRef } from '~/utils/use-gradient-wrapper'

import type { CSSProp } from '../../types'
import type { Props as BoxProps } from '../box/box'
import { Box } from '../box/box'

type Props = BoxProps & {
    scrollableContent?: boolean
}
export const DialogBody = forwardRef<HTMLElement, Props>(
    // oxlint-disable-next-line complexity
    ({ children, css, scrollableContent = false, padding = 'medium', ...props }, propsRef) => {
        const scrollableContentStyles: CSSProp = {
            overflowX: scrollableContent ? 'hidden' : undefined,
            overflowY: scrollableContent ? 'auto' : undefined,
        }
        const { isTopShadowVisible, isBottomShadowVisible, wrapperRef } = useWrapperRef(propsRef)

        return (
            <Box position="relative" display="contents" overflow="visible">
                {scrollableContent && !isVisualRegressionEnv && (
                    <Box
                        css={getGradientStyles({
                            colorToken: 'backgroundEmphasis',
                            direction: 'top',
                        })}
                        opacity={isTopShadowVisible ? 1 : 0}
                    />
                )}
                <Box
                    ref={wrapperRef}
                    padding={padding}
                    backgroundColor="backgroundContent"
                    css={[
                        scrollableContentStyles,
                        css,
                        { minHeight: 0 },
                        scrollableContent ? undefined : { height: '100%' },
                    ]}
                    {...props}
                >
                    {children}
                </Box>
                {scrollableContent && !isVisualRegressionEnv && (
                    <Box
                        css={getGradientStyles({
                            colorToken: 'backgroundEmphasis',
                            direction: 'bottom',
                        })}
                        opacity={isBottomShadowVisible ? 1 : 0}
                    />
                )}
            </Box>
        )
    },
)

DialogBody.displayName = 'DialogBody'
